import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import UserProfile from '../components/UserProfile';
import WithUserData from '../HOC/withUserData';
const containerStyle = {
  margin: '6rem 1rem',
};

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resetPassword: false,
    };
  }
  componentWillMount() {
    const params = window.location.href.split('?');
    if (params.length > 1 && params[1] === 'resetPassword') {
      this.setState({ resetPassword: true });
    }
  }
  onIframeToggle = () => {
    window.open('https://ds.epik.io/index.php/s/dLakZTwFPm4oJXc', '_blank');
  };
  render() {
    const { user } = this.props;
    const { resetPassword } = this.state;

    return (
      <div style={containerStyle}>
        <Container fluid className="profileContainer" style={{ padding: '1rem' }}>
          <UserProfile
            toggleIframe={this.onIframeToggle}
            resetPassword={resetPassword}
            profile={user}
          />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(WithUserData(Profile));
